import { BaseReader } from "../base-reader";
import { UserNotification, UserNotificationSchema } from "./user-notifications.types";

export class UserNotificationsReader extends BaseReader {
  /**
   * Subscribe to user positions updates
   * @param subAddr The subaccount address of the user to subscribe to
   * @param apiUrl The WebSocket server URL
   * @param onData Callback function for received user positions data
   * @returns A function to unsubscribe from the user positions updates
   */
  subscribeByAddr(subAddr: string, onData: (data: UserNotification) => void) {
    const topic = `notifications:${subAddr}`;

    return this.deps.ws.subscribe(topic, UserNotificationSchema, onData);
  }
}
